import { gql } from "apollo-boost"

export const UPDATE_ACTIVITY_ESTIMATED_PARTICIPANTS = gql`
  mutation UpdateActivityEstimatedParticipants ($activityId: ID!, $estimatedParticipants: Float!) {
    UpdateActivityEstimatedParticipants(activityId: $activityId, estimatedParticipants: $estimatedParticipants) {
      estimatedParticipants
      id
    }
  }
`